import { put, select } from 'redux-saga/effects';
import toastService from 'modules/Toasts';
import { CUSTOM } from 'modules/Toasts/constants/toastTypes';
import { clearToastsQueue, queueToast } from '../redux/actions';
import {
  selectNotificationModalVisible,
  selectSidebarIsVisible,
} from 'modules/Notifications/redux/selectors';

export function* showToastSaga({ payload }) {
  const sidebarIsVisible = yield select(selectSidebarIsVisible);
  const modalIsVisible = yield select(selectNotificationModalVisible);

  if (sidebarIsVisible || modalIsVisible) {
    yield put(queueToast(payload));
  } else {
    const {
      type,
      notification: { message, details, options, component },
    } = payload;

    if (type !== CUSTOM) {
      toastService.show(type, message, details, options);
    } else {
      toastService.custom(component, options);
    }
  }
}

export function* dismissToastSaga({ payload: { id, clearWaitingQueue } }) {
  if (clearWaitingQueue) {
    toastService.clearWaitingQueue();
    yield put(clearToastsQueue());
  }

  yield toastService.dismiss(id);
}

export function* dismissToastGroupSaga({ payload }) {
  yield toastService.dismissGroup(payload);
}
